export const serverAddress = "https://server.artimber.au";
// export const serverDevAddress = "https://server.dev.artimber.com.au";

// export const serverAddress = "http://localhost:3000";
